var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayerReports = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2006",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6162_194274)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2005.92,
    fill: "#2264FB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2006,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.748 1807.04H836.162L940.025 1924.88L528.789 2029.11L112.64 1924.8L217.748 1807.04Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 2.95858,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.266 1293.96H809.834V1530.08H618.266V1293.96Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.266 1293.96V1292.48H616.786V1293.96H618.266ZM809.834 1293.96H811.314V1292.48H809.834V1293.96ZM809.834 1530.08V1531.56H811.314V1530.08H809.834ZM618.266 1530.08H616.786V1531.56H618.266V1530.08ZM618.266 1295.44H809.834V1292.48H618.266V1295.44ZM808.355 1293.96V1530.08H811.314V1293.96H808.355ZM809.834 1528.6H618.266V1531.56H809.834V1528.6ZM619.745 1530.08V1293.96H616.786V1530.08H619.745Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 1293.96H618.269V1530.08H426.7V1293.96Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 1293.96V1292.48H425.221V1293.96H426.7ZM618.269 1293.96H619.748V1292.48H618.269V1293.96ZM618.269 1530.08V1531.56H619.748V1530.08H618.269ZM426.7 1530.08H425.221V1531.56H426.7V1530.08ZM426.7 1295.44H618.269V1292.48H426.7V1295.44ZM616.79 1293.96V1530.08H619.748V1293.96H616.79ZM618.269 1528.6H426.7V1531.56H618.269V1528.6ZM428.179 1530.08V1293.96H425.221V1530.08H428.179Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.126 1293.96H426.695V1530.08H235.126V1293.96Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.126 1293.96V1292.48H233.647V1293.96H235.126ZM426.695 1293.96H428.174V1292.48H426.695V1293.96ZM426.695 1530.08V1531.56H428.174V1530.08H426.695ZM235.126 1530.08H233.647V1531.56H235.126V1530.08ZM235.126 1295.44H426.695V1292.48H235.126V1295.44ZM425.215 1293.96V1530.08H428.174V1293.96H425.215ZM426.695 1528.6H235.126V1531.56H426.695V1528.6ZM236.605 1530.08V1293.96H233.647V1530.08H236.605Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.266 1057.84H809.834V1293.96H618.266V1057.84Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.266 1057.84V1056.36H616.786V1057.84H618.266ZM809.834 1057.84H811.314V1056.36H809.834V1057.84ZM809.834 1293.96V1295.44H811.314V1293.96H809.834ZM618.266 1293.96H616.786V1295.44H618.266V1293.96ZM618.266 1059.32H809.834V1056.36H618.266V1059.32ZM808.355 1057.84V1293.96H811.314V1057.84H808.355ZM809.834 1292.48H618.266V1295.44H809.834V1292.48ZM619.745 1293.96V1057.84H616.786V1293.96H619.745Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 1057.84H618.269V1293.96H426.7V1057.84Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 1057.84V1056.36H425.221V1057.84H426.7ZM618.269 1057.84H619.748V1056.36H618.269V1057.84ZM618.269 1293.96V1295.44H619.748V1293.96H618.269ZM426.7 1293.96H425.221V1295.44H426.7V1293.96ZM426.7 1059.32H618.269V1056.36H426.7V1059.32ZM616.79 1057.84V1293.96H619.748V1057.84H616.79ZM618.269 1292.48H426.7V1295.44H618.269V1292.48ZM428.179 1293.96V1057.84H425.221V1293.96H428.179Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.126 1057.84H426.695V1293.96H235.126V1057.84Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.126 1057.84V1056.36H233.647V1057.84H235.126ZM426.695 1057.84H428.174V1056.36H426.695V1057.84ZM426.695 1293.96V1295.44H428.174V1293.96H426.695ZM235.126 1293.96H233.647V1295.44H235.126V1293.96ZM235.126 1059.32H426.695V1056.36H235.126V1059.32ZM425.215 1057.84V1293.96H428.174V1057.84H425.215ZM426.695 1292.48H235.126V1295.44H426.695V1292.48ZM236.605 1293.96V1057.84H233.647V1293.96H236.605Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.266 823.947H809.834V1060.07H618.266V823.947Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.266 823.947V822.468H616.786V823.947H618.266ZM809.834 823.947H811.314V822.468H809.834V823.947ZM809.834 1060.07V1061.55H811.314V1060.07H809.834ZM618.266 1060.07H616.786V1061.55H618.266V1060.07ZM618.266 825.427H809.834V822.468H618.266V825.427ZM808.355 823.947V1060.07H811.314V823.947H808.355ZM809.834 1058.59H618.266V1061.55H809.834V1058.59ZM619.745 1060.07V823.947H616.786V1060.07H619.745Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 823.947H618.269V1060.07H426.7V823.947Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 823.947V822.468H425.221V823.947H426.7ZM618.269 823.947H619.748V822.468H618.269V823.947ZM618.269 1060.07V1061.55H619.748V1060.07H618.269ZM426.7 1060.07H425.221V1061.55H426.7V1060.07ZM426.7 825.427H618.269V822.468H426.7V825.427ZM616.79 823.947V1060.07H619.748V823.947H616.79ZM618.269 1058.59H426.7V1061.55H618.269V1058.59ZM428.179 1060.07V823.947H425.221V1060.07H428.179Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.126 823.947H426.695V1060.07H235.126V823.947Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.126 823.947V822.468H233.647V823.947H235.126ZM426.695 823.947H428.174V822.468H426.695V823.947ZM426.695 1060.07V1061.55H428.174V1060.07H426.695ZM235.126 1060.07H233.647V1061.55H235.126V1060.07ZM235.126 825.427H426.695V822.468H235.126V825.427ZM425.215 823.947V1060.07H428.174V823.947H425.215ZM426.695 1058.59H235.126V1061.55H426.695V1058.59ZM236.605 1060.07V823.947H233.647V1060.07H236.605Z",
    fill: "#737E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.034 1654.82H524.711V1532.31H809.837V1178.13H939.034V1654.82Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.932 1654.82H520.255V1532.31H235.129V1178.13H105.932V1654.82Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.034 701.433H524.711V823.948H809.837V1178.13H939.034V701.433Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.932 701.432H520.255V823.947H235.129V1178.13H105.932V701.432Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.932 701.432H520.255V823.947H235.129V1178.13H105.932V701.432Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-26-outside-1_6162_194274",
    maskUnits: "userSpaceOnUse",
    x: 903.514,
    y: -5.979,
    width: 304,
    height: 304,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 903.514,
    y: -5.979,
    width: 304,
    height: 304
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.36 145.946C1171.36 209.969 1119.46 261.87 1055.44 261.87C991.415 261.87 939.514 209.969 939.514 145.946C939.514 81.9223 991.415 30.021 1055.44 30.021C1119.46 30.021 1171.36 81.9223 1171.36 145.946ZM1054.28 145.946C1054.28 146.586 1054.8 147.105 1055.44 147.105C1056.08 147.105 1056.6 146.586 1056.6 145.946C1056.6 145.306 1056.08 144.786 1055.44 144.786C1054.8 144.786 1054.28 145.306 1054.28 145.946Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1171.36 145.946C1171.36 209.969 1119.46 261.87 1055.44 261.87C991.415 261.87 939.514 209.969 939.514 145.946C939.514 81.9223 991.415 30.021 1055.44 30.021C1119.46 30.021 1171.36 81.9223 1171.36 145.946ZM1054.28 145.946C1054.28 146.586 1054.8 147.105 1055.44 147.105C1056.08 147.105 1056.6 146.586 1056.6 145.946C1056.6 145.306 1056.08 144.786 1055.44 144.786C1054.8 144.786 1054.28 145.306 1054.28 145.946Z",
    fill: "#0E2864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.36 145.946C1171.36 209.969 1119.46 261.87 1055.44 261.87C991.415 261.87 939.514 209.969 939.514 145.946C939.514 81.9223 991.415 30.021 1055.44 30.021C1119.46 30.021 1171.36 81.9223 1171.36 145.946ZM1054.28 145.946C1054.28 146.586 1054.8 147.105 1055.44 147.105C1056.08 147.105 1056.6 146.586 1056.6 145.946C1056.6 145.306 1056.08 144.786 1055.44 144.786C1054.8 144.786 1054.28 145.306 1054.28 145.946Z",
    stroke: "#0E2864",
    strokeWidth: 71.0059,
    strokeLinejoin: "round",
    mask: "url(#path-26-outside-1_6162_194274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.5 175.743C1165.05 176.452 1166.55 179.097 1165.74 181.614C1157.46 207.21 1140.52 229.185 1117.75 243.699C1094.98 258.212 1067.91 264.296 1041.21 260.994C1038.59 260.67 1036.82 258.193 1037.26 255.583L1055.11 147.926C1055.19 147.464 1055.67 147.175 1056.06 146.923V146.923V146.923C1056.46 146.671 1056.92 146.358 1057.37 146.484L1162.5 175.743Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.23 255.578C1036.79 258.188 1034.32 259.962 1031.73 259.421C1012.49 255.401 994.561 246.549 979.648 233.663C963.526 219.733 951.554 201.629 945.049 181.339C938.543 161.049 937.756 139.359 942.773 118.651C947.413 99.4965 956.854 81.8679 970.17 67.4101C971.962 65.4644 975.003 65.4716 976.873 67.3425L1053.7 144.204C1054.79 145.297 1055.29 146.85 1055.03 148.375L1037.23 255.578Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.854 67.3614C974.984 65.4909 974.977 62.4502 976.923 60.6586C986.929 51.4471 998.488 44.0594 1011.08 38.8452C1023.66 33.6311 1037.06 30.6817 1050.65 30.1199C1053.29 30.0107 1055.44 32.1654 1055.44 34.8107L1055.44 144.331C1055.44 144.583 1055.23 144.779 1054.99 144.875V144.875V144.875C1054.76 144.971 1054.47 144.982 1054.3 144.804L976.854 67.3614Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.44 34.8107C1055.44 32.1654 1057.58 30.0107 1060.23 30.1199C1076.46 30.7909 1092.39 34.8671 1106.97 42.1043C1122.99 50.052 1136.95 61.5965 1147.76 75.8351C1158.57 90.0738 1165.95 106.621 1169.3 124.182C1172.36 140.173 1172.01 156.611 1168.3 172.426C1167.69 175.002 1165.04 176.49 1162.49 175.78L1057.07 146.4C1056.79 146.321 1056.63 146.018 1056.58 145.728V145.728C1056.54 145.552 1056.47 145.387 1056.36 145.245C1056.25 145.102 1056.11 144.987 1055.95 144.907V144.907C1055.69 144.776 1055.44 144.547 1055.44 144.252L1055.44 34.8107Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.8 -84.9997C1426.44 -84.9782 1428.58 -82.8151 1428.45 -80.1731C1427.52 -61.3139 1421.99 -42.9417 1412.32 -26.6691C1401.83 -9.02213 1386.84 5.52259 1368.88 15.4781C1350.93 25.4336 1330.65 30.4427 1310.13 29.9933C1291.2 29.579 1272.69 24.5369 1256.2 15.3395C1253.89 14.051 1253.19 11.0925 1254.57 8.83742L1311.74 -84.3934C1311.92 -84.6817 1312.3 -84.7521 1312.64 -84.7447V-84.7447C1312.85 -84.7402 1313.05 -84.7903 1313.23 -84.8898C1313.41 -84.9894 1313.56 -85.1348 1313.66 -85.3113V-85.3113C1313.84 -85.602 1314.1 -85.892 1314.44 -85.8892L1423.8 -84.9997Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.48 8.78139C1253.1 11.0351 1250.14 11.7475 1247.94 10.2706C1230.58 -1.41348 1216.68 -17.5997 1207.75 -36.5935C1198.15 -57.0344 1194.72 -79.8366 1197.89 -102.198C1201.07 -124.56 1210.71 -145.508 1225.62 -162.467C1239.49 -178.225 1257.34 -189.902 1277.27 -196.292C1279.79 -197.1 1282.43 -195.593 1283.13 -193.043L1312.11 -87.9106C1312.47 -86.6304 1312.27 -85.2613 1311.58 -84.13L1254.48 8.78139Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.81 433.558C1411.1 434.885 1411.89 437.821 1410.47 440.053C1397.66 460.167 1378.95 475.881 1356.83 484.993C1334.71 494.106 1310.36 496.139 1287.1 490.881C1284.52 490.297 1283.01 487.658 1283.7 485.104L1312.17 379.662C1312.28 379.257 1312.72 379.041 1313.11 378.882V378.882V378.882C1313.5 378.722 1313.96 378.562 1314.33 378.772L1408.81 433.558Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.72 485.109C1283.03 487.663 1280.4 489.184 1277.88 488.391C1257.37 481.94 1239.04 469.906 1224.95 453.595C1209.81 436.074 1200.27 414.422 1197.55 391.428C1194.83 368.435 1199.05 345.154 1209.68 324.585C1219.58 305.436 1234.6 289.455 1253.03 278.399C1255.3 277.039 1258.22 277.904 1259.48 280.227L1311.75 376.124C1312.34 377.206 1312.49 378.474 1312.17 379.664L1283.72 485.109Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.51 280.214C1258.24 277.891 1259.1 274.972 1261.47 273.804C1281.91 263.743 1304.86 259.926 1327.45 262.832C1330.08 263.17 1331.83 265.655 1331.38 268.262L1312.93 376.286C1312.89 376.496 1312.69 376.631 1312.48 376.666V376.666C1312.27 376.702 1312.03 376.64 1311.93 376.452L1259.51 280.214Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.41 268.267C1331.86 265.66 1334.34 263.898 1336.92 264.451C1353.62 268.023 1369.33 275.241 1382.94 285.611C1397.82 296.95 1409.73 311.721 1417.66 328.663C1425.59 345.604 1429.3 364.214 1428.48 382.902C1427.73 399.993 1423.21 416.685 1415.26 431.79C1414.03 434.131 1411.09 434.906 1408.8 433.578L1314.15 378.672C1313.89 378.517 1313.81 378.169 1313.83 377.861V377.861C1313.83 377.674 1313.8 377.488 1313.72 377.319C1313.64 377.149 1313.52 377.001 1313.37 376.888V376.888C1313.13 376.701 1312.91 376.421 1312.96 376.117L1331.41 268.267Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.03 181.979C1677.53 182.837 1678.87 185.565 1677.91 188.03C1671.25 205.124 1660.62 220.417 1646.87 232.628C1631.92 245.901 1613.8 255.083 1594.25 259.283C1574.71 263.483 1554.41 262.558 1535.33 256.597C1517.78 251.113 1501.8 241.538 1488.71 228.689C1486.82 226.836 1486.92 223.797 1488.85 221.987L1568.62 147.147C1568.86 146.922 1569.24 146.954 1569.55 147.052V147.052C1569.74 147.112 1569.95 147.121 1570.14 147.079C1570.34 147.037 1570.52 146.945 1570.67 146.813V146.813C1570.91 146.594 1571.25 146.408 1571.56 146.515L1675.03 181.979Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.86 222C1486.93 223.811 1483.89 223.721 1482.16 221.719C1469.71 207.303 1460.99 190.02 1456.8 171.388C1452.26 151.196 1453.2 130.156 1459.54 110.454C1465.88 90.751 1477.37 73.1041 1492.83 59.3455C1507.1 46.6497 1524.26 37.692 1542.78 33.2366C1545.35 32.6179 1547.88 34.3167 1548.39 36.9119L1569.55 144.203C1569.62 144.537 1569.38 144.853 1569.13 145.08V145.08C1568.97 145.217 1568.86 145.394 1568.79 145.591C1568.73 145.788 1568.72 145.998 1568.77 146.2V146.2C1568.84 146.533 1568.85 146.928 1568.6 147.161L1488.86 222Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.39 36.9112C1547.88 34.3159 1549.57 31.7867 1552.18 31.3825C1560.25 30.1344 1568.44 29.7428 1576.59 30.2143C1579.23 30.367 1581.15 32.7234 1580.89 35.3557L1570.03 144.623C1570.02 144.716 1569.94 144.783 1569.84 144.788V144.788C1569.75 144.792 1569.66 144.734 1569.64 144.641L1548.39 36.9112Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.01 35.3676C1581.27 32.7356 1583.62 30.8061 1586.24 31.1791C1601.92 33.4122 1617 38.8377 1630.53 47.1387C1645.42 56.2756 1658.05 68.66 1667.48 83.3662C1676.91 98.0724 1682.9 114.72 1684.99 132.065C1686.89 147.823 1685.53 163.786 1681.02 178.968C1680.27 181.504 1677.53 182.834 1675.03 181.977L1571.49 146.491C1571.22 146.397 1571.08 146.093 1571.05 145.807V145.807C1571.03 145.633 1570.97 145.467 1570.87 145.32C1570.78 145.173 1570.65 145.049 1570.5 144.958V144.958C1570.26 144.807 1570.04 144.56 1570.07 144.273L1581.01 35.3676Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.39 707.609C1516.14 709.941 1513.23 710.826 1510.96 709.481C1497.93 701.79 1486.52 691.614 1477.39 679.517C1467.29 666.145 1460.21 650.742 1456.64 634.37C1453.07 617.999 1453.08 601.047 1456.69 584.684C1459.96 569.882 1466.09 555.879 1474.73 543.46C1476.24 541.289 1479.26 540.882 1481.36 542.481L1568.58 608.656C1568.8 608.823 1568.82 609.14 1568.77 609.41V609.41C1568.73 609.573 1568.73 609.743 1568.76 609.906C1568.8 610.07 1568.87 610.224 1568.97 610.358V610.358C1569.14 610.579 1569.24 610.879 1569.11 611.122L1517.39 707.609Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.6 498.573C1566.52 495.929 1568.6 493.712 1571.25 493.742C1593.33 493.999 1614.91 500.56 1633.44 512.701C1651.96 524.841 1666.6 542.015 1675.64 562.159C1676.73 564.572 1675.52 567.365 1673.07 568.348L1571.63 608.966C1571.27 609.111 1570.86 608.904 1570.53 608.69V608.69V608.69C1570.21 608.476 1569.85 608.184 1569.84 607.794L1566.6 498.573Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.36 542.484C1479.25 540.885 1478.84 537.874 1480.52 535.834C1490.5 523.748 1502.84 513.799 1516.81 506.606C1530.77 499.412 1546.04 495.139 1561.67 494.027C1564.31 493.839 1566.52 495.929 1566.6 498.573L1569.85 607.984C1569.86 608.269 1569.62 608.498 1569.37 608.629V608.629V608.629C1569.11 608.76 1568.79 608.819 1568.56 608.646L1481.36 542.484Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.08 568.382C1675.54 567.4 1678.34 568.592 1679.22 571.086C1686.58 591.949 1687.83 614.519 1682.76 636.124C1677.33 659.285 1664.91 680.215 1647.17 696.072C1629.44 711.93 1607.26 721.948 1583.63 724.767C1561.6 727.397 1539.31 723.644 1519.4 714.006C1517.01 712.853 1516.14 709.94 1517.39 707.609L1569.02 611.305C1569.2 610.96 1569.65 610.857 1570.03 610.81V610.81C1570.27 610.782 1570.49 610.682 1570.67 610.523C1570.85 610.365 1570.97 610.156 1571.03 609.924V609.924C1571.12 609.543 1571.27 609.111 1571.63 608.966L1673.08 568.382Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.86 -166.299C1905.68 -168.213 1908.72 -168.29 1910.56 -166.386C1929.76 -146.484 1941.25 -120.325 1942.86 -92.6127C1944.56 -63.3037 1935.07 -34.4416 1916.32 -11.8536C1897.57 10.7344 1870.94 25.3657 1841.82 29.0864C1814.28 32.6043 1786.46 26.1205 1763.36 10.9093C1761.15 9.45426 1760.67 6.45186 1762.22 4.3047L1825.94 -84.2562C1826.22 -84.6464 1826.8 -84.6928 1827.27 -84.7537V-84.7537C1827.57 -84.7909 1827.83 -84.9372 1828.02 -85.1631C1828.21 -85.389 1828.3 -85.6776 1828.28 -85.9707V-85.9707C1828.26 -86.4506 1828.2 -87.0241 1828.53 -87.3719L1903.86 -166.299Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.16 4.26764C1760.62 6.41393 1757.62 6.90803 1755.54 5.27444C1740.27 -6.71456 1728.23 -22.3647 1720.57 -40.2572C1712.27 -59.6192 1709.41 -80.8752 1712.29 -101.741C1715.17 -122.608 1723.68 -142.296 1736.9 -158.69C1749.12 -173.84 1764.94 -185.648 1782.89 -193.056C1785.33 -194.065 1788.09 -192.778 1789 -190.293L1826.51 -87.5824C1826.63 -87.2566 1826.44 -86.9014 1826.22 -86.6315V-86.6315C1826.09 -86.4675 1826.01 -86.2707 1825.98 -86.062C1825.95 -85.8533 1825.98 -85.6408 1826.06 -85.4472V-85.4472C1826.2 -85.1283 1826.28 -84.7349 1826.08 -84.4535L1762.16 4.26764Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823.02 266.751C1822.92 264.107 1824.99 261.875 1827.63 261.886C1844.97 261.962 1862.07 265.926 1877.67 273.485C1880.05 274.639 1880.92 277.552 1879.67 279.883L1827.82 376.518C1827.74 376.667 1827.55 376.719 1827.39 376.681V376.681C1827.22 376.642 1827.08 376.514 1827.07 376.345L1823.02 266.751Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.23 385.142C1713.59 385.317 1711.3 383.318 1711.24 380.673C1710.61 355.261 1718.35 330.295 1733.35 309.66C1748.35 289.025 1769.7 273.95 1794.06 266.7C1796.6 265.946 1799.21 267.508 1799.86 270.072L1826.64 375.906C1826.75 376.337 1826.45 376.769 1826.19 377.129V377.129V377.129C1825.93 377.488 1825.61 377.91 1825.17 377.94L1716.23 385.142Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.89 270.065C1799.24 267.501 1800.79 264.886 1803.38 264.344C1808.23 263.329 1813.14 262.626 1818.07 262.239C1820.71 262.033 1822.93 264.107 1823.03 266.75L1827.08 376.529C1827.08 376.597 1827.03 376.653 1826.96 376.662V376.662C1826.9 376.672 1826.83 376.633 1826.81 376.568L1799.89 270.065Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.64 279.867C1880.89 277.535 1883.8 276.65 1886.08 277.996C1902.04 287.421 1915.53 300.548 1925.38 316.296C1936.09 333.399 1942.15 353.001 1942.96 373.163C1943.77 393.325 1939.3 413.35 1930 431.255C1920.69 449.161 1906.88 464.329 1889.92 475.258C1872.95 486.187 1853.43 492.5 1833.28 493.571C1813.13 494.643 1793.05 490.436 1775.03 481.367C1757 472.298 1741.65 458.681 1730.51 441.863C1720.24 426.377 1713.86 408.671 1711.87 390.245C1711.59 387.615 1713.6 385.331 1716.23 385.157L1825.37 377.926C1825.7 377.904 1825.98 378.173 1826.16 378.451V378.451C1826.27 378.619 1826.43 378.755 1826.61 378.846C1826.79 378.936 1826.99 378.978 1827.19 378.968C1827.39 378.957 1827.59 378.894 1827.75 378.784C1827.92 378.675 1828.06 378.524 1828.16 378.344C1828.25 378.165 1828.29 377.965 1828.29 377.764C1828.28 377.562 1828.22 377.366 1828.11 377.195V377.195C1827.93 376.913 1827.8 376.551 1827.96 376.258L1879.64 279.867Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.83 741.63C1876.99 739.252 1879.87 738.256 1882.19 739.512C1907.74 753.301 1927.24 776.212 1936.73 803.768C1946.74 832.837 1944.8 864.693 1931.33 892.328C1917.85 919.963 1893.95 941.114 1864.88 951.128C1837.33 960.62 1807.27 959.367 1780.67 947.733C1778.25 946.673 1777.26 943.795 1778.42 941.417L1826.22 843.384C1826.44 842.932 1827.03 842.783 1827.5 842.62V842.62C1827.8 842.52 1828.03 842.308 1828.17 842.032C1828.3 841.755 1828.32 841.437 1828.22 841.146V841.146C1828.06 840.671 1827.81 840.115 1828.03 839.663L1875.83 741.63Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.43 941.424C1777.28 943.802 1774.4 944.798 1772.07 943.542C1756.36 935.064 1742.8 923.06 1732.47 908.448C1721.22 892.53 1714.16 874.032 1711.95 854.663C1709.74 835.294 1712.45 815.681 1719.83 797.638C1726.61 781.074 1737.11 766.324 1750.51 754.525C1752.5 752.777 1755.52 753.101 1757.19 755.157L1826.03 840.171C1826.23 840.42 1826.18 840.787 1826.05 841.085V841.085C1825.98 841.265 1825.95 841.461 1825.98 841.655C1826 841.849 1826.07 842.034 1826.18 842.193V842.193C1826.37 842.455 1826.5 842.8 1826.36 843.089L1778.43 941.424Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.18 755.164C1755.51 753.109 1755.82 750.084 1757.94 748.505C1776.63 734.607 1799.08 726.658 1822.34 725.698C1824.99 725.588 1827.13 727.743 1827.13 730.389L1827.13 839.97C1827.13 840.188 1826.95 840.358 1826.74 840.431V840.431C1826.53 840.504 1826.29 840.486 1826.15 840.316L1757.18 755.164Z",
    fill: "black",
    fillOpacity: 0.4,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.13 730.389C1827.13 727.743 1829.27 725.589 1831.92 725.698C1846.28 726.292 1860.41 729.552 1873.58 735.314C1876 736.374 1876.99 739.251 1875.83 741.628L1827.75 840.245C1827.69 840.376 1827.53 840.427 1827.39 840.394V840.394C1827.25 840.361 1827.13 840.247 1827.13 840.101L1827.13 730.389Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973.25 143.395C1970.61 143.334 1968.5 141.139 1968.67 138.5C1970.21 114.707 1979.04 91.9215 1994.04 73.2858C2009.04 54.6502 2029.4 41.1406 2052.32 34.5513C2054.86 33.8202 2057.45 35.4066 2058.08 37.9768L2083.9 144.097C2084 144.504 2083.72 144.907 2083.45 145.234V145.234V145.234C2083.19 145.56 2082.86 145.926 2082.44 145.916L1973.25 143.395Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2086.89 34.8543C2086.95 32.2097 2089.15 30.1044 2091.79 30.274C2113.01 31.6368 2133.48 38.8158 2150.94 51.0669C2169.71 64.2365 2184.15 82.6758 2192.44 104.053C2200.73 125.43 2202.49 148.785 2197.51 171.164C2192.52 193.544 2181.01 213.942 2164.44 229.78C2147.86 245.619 2126.96 256.185 2104.37 260.144C2081.79 264.103 2058.54 261.276 2037.56 252.021C2016.59 242.766 1998.82 227.498 1986.52 208.149C1975.08 190.149 1968.84 169.369 1968.45 148.105C1968.4 145.46 1970.61 143.365 1973.25 143.425L2082.51 145.918C2082.89 145.927 2083.18 146.264 2083.38 146.582V146.582C2083.5 146.776 2083.68 146.928 2083.89 147.021C2084.1 147.114 2084.33 147.142 2084.56 147.102C2084.78 147.063 2084.99 146.957 2085.16 146.799C2085.32 146.64 2085.44 146.436 2085.49 146.212C2085.54 145.989 2085.52 145.755 2085.44 145.541C2085.35 145.328 2085.21 145.143 2085.02 145.011V145.011C2084.71 144.795 2084.39 144.496 2084.4 144.119L2086.89 34.8543Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084.36 720.809C2084.36 723.455 2082.21 725.609 2079.57 725.5C2050.56 724.302 2022.99 712.254 2002.39 691.645C1980.65 669.905 1968.43 640.419 1968.43 609.674C1968.43 578.929 1980.65 549.443 2002.39 527.703C2022.99 507.094 2050.56 495.047 2079.57 493.848C2082.21 493.739 2084.36 495.894 2084.36 498.539L2084.36 609.674L2084.36 720.809Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#737E99",
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.56 66.8829L1957.88 29.4919L1914.41 -9.49121M1742.06 -164.082L1656.45 -240.876M1483.63 -239.063L1398.52 -162.344M1226.87 -7.6246L1141.43 69.3983M1141.43 223.444L1227.42 300.955M1398.44 455.119L1442.12 494.489L1484.12 532.354M1656.43 687.67L1740.72 763.652M1914.41 764.865L1998.29 689.228M2171.13 533.37L2256.28 456.588M2257.03 297.817L2171.81 221.379M1998.29 224.337L1913.74 300.367M1398.58 -9.03577L1483.59 67.4018M1656.43 68.4997L1740.83 -7.7649M1656.43 222.814L1740.83 298.703M1741.78 454.986L1655.8 532.296M1913.71 454.154L2000.15 531.88M1399.18 300.955L1483.59 224.682",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6162_194274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2005.92,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayerReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlayerReports.49b36d0e0ce74931641c9959040c4ae1.svg";